import React, {useEffect, useState, useRef} from 'react';
import $ from "../../utils/datatables";
import { Link, useHistory } from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import moment from "moment";
import { toast } from 'react-toastify';
import {GET_SCHEME_APPLICATIONS_BY_COMPANY_URL} from "../../api";
import {getCurrentUser} from "../../api/web";
import {SET_AUTH_USER} from "../../stores/auth";

const SchemeApplication = (props) => {
    const history = useHistory();
    const [editForm, setEditForm] = useState(false);
    const [stateReady, setStateReady] = useState(false);
    const [editId, setEditId] = useState(null);
    const [pacraId, setPacraId] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState({ name: 'All', value: 'all' });
    const selectedStatusRef = useRef('all');

    const token = localStorage.getItem('jwtToken');
    const dispatch = useDispatch();
    const authState = useSelector((state) => state.auth.user);
    const user = authState?.user;

    useEffect(() => {
        if (user?.company?.pacra_id) {
            setPacraId(user.company.pacra_id);
            return;
        }
        if (!token) return;
        getCurrentUser()
            .then((data) => {
                if (data?.company?.pacra_id) {
                    setPacraId(data.company.pacra_id);
                    dispatch(SET_AUTH_USER({ user: data, token: authState?.token || token, isAuthenticated: true }));
                }
            })
            .catch(() => {});
    }, [token, user?.company?.pacra_id, authState?.token, dispatch]);

    useEffect(() => {
        if (!pacraId) return;
        let table = $('#scheme_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Scheme Application Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                const page = Math.floor(data.start / data.length) + 1;
                const status = selectedStatusRef.current || 'all';
                const url = GET_SCHEME_APPLICATIONS_BY_COMPANY_URL(pacraId, page, data.length, status);
                $.ajax(url, {
                    type: 'GET',
                    headers: {
                        Authorization: token ? 'Token ' + token : ''
                    },
                    success : function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load scheme applications', { position: "top-right", autoClose: 5000 });
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return (data?.scheme?.scheme_name) ?? '—';
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.farmer ? `${data.farmer.first_name} ${data.farmer.last_name}` : "No Farmer";
                        },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        const statusMap = {
                            "approved": `<span class="badge bg-success text-white">Approved</span>`,
                            "rejected": `<span class="badge bg-danger text-white">Rejected</span>`,
                            "pending": `<span class="badge text-white" style="background-color:#fd7e14">Pending</span>`
                        };
                        return statusMap[data?.application_status] ?? (data?.application_status ?? '—');
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data?.date_approved ? moment(data.date_approved).format("Do MMM, YYYY") : "No Date Set";
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return data?.date_added ? moment(data.date_added).format("Do MMM, YYYY") : '—';
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        const appId = data?.id;
                        if (appId == null) return '—';
                        return '<a href="#" class="nav-link view_application"><i class="fa fa-eye"></i> View</a>';
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.view_application', function(e) {
            e.preventDefault();
            const rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id != null) {
                history.push('/scheme_application/' + rowData.raw.id);
            }
            return false;
        });

        table.on('click', '.view_crop', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $("#scheme_title").text(`${extract_td.raw.scheme_name} Scheme`);

            extract_td.raw.crops.map((item, index) => {
                $("#scheme_data").append(`
                    <p><h5 class="tx-primary">Crop ${index+1}</h5></p>
                    <p><strong>ID:</strong> <span>${item.id}</span></p>
                    <p><strong>Name:</strong> <span>${item.name}</span></p>
                    <p><strong>Description:</strong> <span>${item.description}</span></p>
                    <p><strong>Crop Type:</strong> <span>${item.crop_type || "Not Set"}</span></p>
                    <p><strong>Date Created:</strong> <span>${moment(item.created_at).format("Do MMM, YYYY")}</span></p>
                    <hr/>`)
            });

            $("#modalScheme").modal({ backdrop: "static", keyboard: false }, "show");
        });

        table.on('click', '.view_input', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $("#scheme_title").text(`${extract_td.raw.scheme_name} Scheme`);

            extract_td.raw.inputs.map((item, index) => {
                $("#scheme_data").append(`
                    <p><h5 class="tx-primary">Input ${index+1}</h5></p>
                    <p><strong>ID:</strong> <span>${item.id}</span></p>
                    <p><strong>Name:</strong> <span>${item.name}</span></p>
                    <p><strong>Description:</strong> <span>${item.description}</span></p>
                    <p><strong>Input Type:</strong> <span>${item.input_type || "Not Set"}</span></p>
                    <p><strong>Metric:</strong> <span>${item.metric || "Not Set"}</span></p>
                    <p><strong>Price:</strong> <span>${item.price}</span></p>
                    <p><strong>Unit:</strong> <span>${item.unit}</span></p>
                    <p><strong>Currency:</strong> <span>${item.currency}</span></p>
                    <p><strong>Date Created:</strong> <span>${moment(item.created_at).format("Do MMM, YYYY")}</span></p>
                    <hr/>`)
            });

            $("#modalScheme").modal({ backdrop: "static", keyboard: false }, "show");
        });

        table.on('click', '.view_prerequisites', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $("#scheme_title").text(`${extract_td.raw.scheme_name} Scheme`);

            extract_td.raw.prerequisites.map((item, index) => {
                $("#scheme_data").append(`
                    <p><h5 class="tx-primary">Prerequisites ${index+1}</h5></p>
                    <p><strong>ID:</strong> <span>${item.id}</span></p>
                    <p><strong>Type:</strong> <span>${item.type}</span></p>
                    <p><strong>Description:</strong> <span>${item.description}</span></p>
                    <p><strong>Value:</strong> <span>${item.value}</span></p>
                    <hr/>`)
            });

            $("#modalScheme").modal({ backdrop: "static", keyboard: false }, "show");
        });

        return function cleanup() {
            if ($.fn.DataTable.isDataTable('#scheme_table')) {
                $('#scheme_table').DataTable().destroy();
                $('#scheme_table').empty();
            }
        };
    }, [pacraId, token, history]);

    const reloadTable = () => {
        $('#scheme_table').DataTable().ajax.reload(null, false);
    };

    const statusOptions = [
        { name: 'All', value: 'all' },
        { name: 'Pending', value: 'pending' },
        { name: 'Approved', value: 'approved' },
        { name: 'Rejected', value: 'rejected' }
    ];

    const handleStatusChange = (opt) => {
        selectedStatusRef.current = opt.value;
        setSelectedStatus({ name: opt.name, value: opt.value });
        reloadTable();
    };

    const handleShowModal = () => {
        setEditForm(false);
        $('#scheme_form').parsley();
        $("#modalSchemeForm").modal({ backdrop: "static", keyboard: false }, "show");
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const onCloseModal = () => {
        $('#scheme_data').empty();
        $(`#modalScheme`).modal("hide");
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Scheme Applications</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Scheme Applications</h4>
                    </div>
                    <div className="dropdown">
                        <button
                            className="btn btn-sm btn-secondary dropdown-toggle"
                            type="button"
                            id="schemeAppStatusDropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-bs-toggle="dropdown"
                        >
                            {selectedStatus.name}
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="schemeAppStatusDropdown">
                            {statusOptions.map((opt) => (
                                <li key={opt.value}>
                                    <button
                                        type="button"
                                        className={`dropdown-item ${selectedStatus.value === opt.value ? 'active' : ''}`}
                                        onClick={() => handleStatusChange(opt)}
                                    >
                                        {opt.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Scheme Applications</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="scheme_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Scheme Name</th>
                                        <th className="wd-20p">Farmer</th>
                                        <th className="wd-20p">Status</th>
                                        <th className="wd-20p">Date Approved</th>
                                        <th className="wd-20p">Date Created</th>
                                        <th className="wd-10p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalUser" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></a>
                                <div className="media-body">
                                    <a href="" role="button" className="close pos-absolute t-15 r-15" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></a>
                                    <h4 className="tx-18 tx-sm-20 mg-b-2" id="title">User Detail</h4>
                                    <p className="tx-13 tx-color-02 mg-b-0">User full information.</p>
                                </div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <div className="row row-sm">
                                    <div className="col-md-12">
                                        <p><strong>ID Number:</strong> <span id="id_number">Blank</span></p>
                                        <p><strong>First Name:</strong> <span id="first_name">Blank</span></p>
                                        <p><strong>Last Name:</strong> <span id="last_name">Blank</span></p>
                                        <p><strong>Username:</strong> <span id="username">Blank</span></p>
                                        <p><strong>Phone Number:</strong> <span id="phone_number">Blank</span></p>
                                        <p><strong>Email Address:</strong> <span id="email_address">Blank</span></p>
                                        <p><strong>Verified:</strong> <span id="verified">Blank</span></p>
                                        <p><strong>Active:</strong> <span id="active">Blank</span></p>
                                        <p><strong>Date Joined:</strong> <span id="date_joined">Blank</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalScheme" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></a>
                                <div className="media-body">
                                    <a href="" role="button" className="close pos-absolute t-15 r-15" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true" onClick={onCloseModal.bind()}>×</span></a>
                                    <h4 className="tx-18 tx-sm-20 mg-b-2" id="scheme_title">Scheme Detail</h4>
                                    <p className="tx-13 tx-color-02 mg-b-0">Scheme information.</p>
                                </div>
                            </div>
                            <div className="modal-body pd-sm-t-10 pd-sm-b-40 pd-sm-x-30">
                                <div className="row row-sm">
                                    <div id="scheme_data" className="col-md-12">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SchemeApplication;
